export class BootstrapSize {
	xs: string;
	sm: string;
	md: string;
	lg: string;
	xl: string;

	constructor(xs = '12', sm = '12', md = '12', lg = '12', xl = '12') {
		this.xs = xs;
		this.sm = sm;
		this.md = md;
		this.lg = lg;
		this.xl = xl;
	}

	static formPipe(pipe: string): BootstrapSize {
		const sizes: string[] = pipe.split('|');

		return new BootstrapSize(
			sizes[0] || '12',
			sizes[1] || '12',
			sizes[2] || '12',
			sizes[3] || '12',
			sizes[4] || '12'
		);
	}

	toClass(): string {
		return `col-xs-${this.xs} col-sm-${this.sm} col-md-${this.md} col-lg-${this.lg} col-xl-${this.xl}`;
	}

	/* toClass(size: string): string {
    if (size === undefined) {
      return 'col-xs-12 col-sm-12 col-md-12 col-lg-12';
    } else {
      const sizes: string[] = size.split('|');

      let str = '';

      if (sizes[0]) {
        str += `col-xs-${sizes[0]}`;
      }

      if (sizes[1]) {
        str += ` col-sm-${sizes[1]}`;
      }

      if (sizes[2]) {
        str += ` col-md-${sizes[2]}`;
      }

      if (sizes[3]) {
        str += ` col-lg-${sizes[3]}`;
      }

      if (sizes[4]) {
        str += ` col-xl-${sizes[4]}`;
      }

      return str;
    }
  } */
}
